<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebarg">
<p class="imagec" id="contents"><a id="page_5"></a><img alt="Image" height="15" src="images/rstar.jpg" width="15"/></p>
<p class="contents"><strong>CONTENTS</strong></p>
<p class="toc"><a class="nounder" href="#/xhtml/introduction#introduction"><span class="blue"><strong>INTRODUCTION</strong></span></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01"><strong><span class="red">1:</span> <span class="blue">COMPOSTING = STEWARDSHIP</span></strong></a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><strong><span class="red">2:</span> <span class="blue">PLANNING = VISION</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong><span class="red">3:</span> <span class="blue">TILLING = INITIATIVE</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong><span class="red">4:</span> <span class="blue">SOWING = FAITH</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong><span class="red">5:</span> <span class="blue">GROWING = PATIENCE</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong><span class="red">6:</span> <span class="blue">HEALING = COMPASSION</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong><span class="red">7:</span> <span class="blue">REAPING = GRATITUDE</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong><span class="red">8:</span> <span class="blue">SHARING = GENEROSITY</span></strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><strong><span class="red">9:</span> <span class="blue">SUSTAINING = PERSEVERANCE</span></strong></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/resources#resources" title="Link target outside of Sample"><span class="blue"><strong>RESOURCES: FARMER D’S TOOL CHEST</strong></span></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/app01#app01" title="Link target outside of Sample"><span class="blue"><strong>ACKNOWLEDGMENTS</strong></span></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><span class="blue"><strong>INDEX OF SEARCHABLE TERMS</strong></span></span></p>
</div>
<p class="image-b"><a id="page_6"></a><img alt="Image" height="550" src="images/f0006-01.jpg" width="438"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0dc86c2a